import { render } from "./SummaryAsset.vue?vue&type=template&id=5802901c&scoped=true&ts=true"
import script from "./SummaryAsset.vue?vue&type=script&lang=ts"
export * from "./SummaryAsset.vue?vue&type=script&lang=ts"

import "./SummaryAsset.vue?vue&type=style&index=0&id=5802901c&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5802901c"]])

export default __exports__